// extracted by mini-css-extract-plugin
export default {"textData":"textData_textData__HgMZ4","textItemData":"textData_textItemData__jxbnk"};